import { ApplicationOutlineIcon } from './ApplicationOutlineIcon';

/**
 * author: Austin Andrews
 * id 55C0C50F-9F4D-44C4-A84B-C79F645A8604
 * name application-outline
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/application-outline.svg
 * tags
 */
export const WebAssetIcon = ApplicationOutlineIcon;
export default WebAssetIcon